var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSideHeadLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 36,
    viewBox: "0 0 85 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_315_2830",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 36
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "67d0d6b245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H23.6148V36H0V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_315_2830)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.4971 30.4537C21.2292 28.7497 25.5148 22.1837 22.5091 9.2975C20.0787 2.48801 14.5133 2.79037 12.6568 0.668727C12.3122 0.288216 11.8305 0.0652897 11.3206 0.0358223C10.6364 -5.0813e-05 9.90997 0.374055 9.59351 0.913434C8.07019 3.53089 5.64619 3.53089 3.14403 6.68004C-0.213951 10.9156 -0.106332 17.647 0.741812 22.1977C1.44646 26.0016 5.10681 30.7842 8.07019 32.56C9.26297 33.2787 9.11948 32.8047 10.033 34.6457C10.3776 35.3427 11.3129 36.3138 12.2046 35.8757C12.6786 35.6451 12.8298 35.171 12.9233 34.7316C13.0963 33.9846 13.9009 32.0923 17.4971 30.4537Z",
    fill: "#C1FF72"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.5383 25.2616H25.2886V12.0039H27.5383V25.2616ZM27.5383 9.49279H25.2886V6.94067H27.5383V9.49279Z",
    fill: "#C1FF72"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M47.2066 25.2624H44.9568V16.8886C44.9568 16.2737 44.9132 15.7484 44.8287 15.3102C44.7467 14.8733 44.5327 14.4851 44.1881 14.1469C43.8422 13.8087 43.3028 13.6395 42.5687 13.6395C41.6834 13.6395 40.9198 13.9496 40.2779 14.5671C39.6386 15.1821 39.3196 16.1814 39.3196 17.5651V25.2624H37.0698V16.6375C37.0698 15.4896 36.8661 14.7042 36.46 14.2801C36.0564 13.8535 35.4837 13.6395 34.7432 13.6395C33.7798 13.6395 32.9867 13.9727 32.3653 14.6389C31.7427 15.3051 31.4326 16.5504 31.4326 18.3748V25.2624H29.1829V12.0048H31.2071V13.8548H31.2584C32.1565 12.4199 33.4774 11.7024 35.2198 11.7024C36.1935 11.7024 36.9942 11.8971 37.6233 12.2866C38.2549 12.6735 38.7123 13.2539 38.9967 14.029C39.9768 12.4788 41.3387 11.7024 43.0811 11.7024C44.4546 11.7024 45.4846 12.0739 46.1714 12.8145C46.8606 13.5563 47.2066 14.6683 47.2066 16.1507V25.2624Z",
    fill: "#C1FF72"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M51.1238 13.4898C51.9565 12.2983 53.1493 11.7013 54.7008 11.7013C56.4048 11.7013 57.7705 12.324 58.7955 13.5667C59.8204 14.8069 60.3329 16.4263 60.3329 18.425C60.3329 20.7349 59.7602 22.5043 58.6161 23.7342C57.4707 24.9616 56.1319 25.574 54.5983 25.574C53.0404 25.574 51.8271 24.9167 50.9598 23.601H50.9136V25.2614H48.8125V6.94043H51.0623V13.4898H51.1238ZM54.4241 23.7239C55.4657 23.7239 56.3254 23.2768 57.0018 22.3813C57.6809 21.487 58.0217 20.2314 58.0217 18.6146C58.0217 17.0567 57.709 15.8216 57.0838 14.9094C56.4586 13.9972 55.5977 13.5411 54.501 13.5411C53.4171 13.5411 52.5446 14.0126 51.8822 14.9555C51.2186 15.8959 50.888 17.0861 50.888 18.5275C50.888 19.9355 51.0238 20.9361 51.298 21.5306C51.5747 22.125 51.9898 22.6401 52.5433 23.0731C53.0968 23.5074 53.7233 23.7239 54.4241 23.7239Z",
    fill: "#C1FF72"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M72.826 19.1999H62.8943C62.9865 20.6694 63.4042 21.7917 64.1498 22.5668C64.8942 23.3394 65.8256 23.725 66.9428 23.725C67.7999 23.725 68.5187 23.4983 69.1003 23.0434C69.6845 22.5899 70.1317 21.9045 70.443 20.9884L72.7543 21.2754C72.3776 22.6591 71.6896 23.7225 70.689 24.463C69.691 25.2048 68.4418 25.5751 66.9428 25.5751C64.9506 25.5751 63.3939 24.9652 62.2742 23.7455C61.1531 22.5233 60.5933 20.8539 60.5933 18.7387C60.5933 16.6478 61.1365 14.954 62.2229 13.6549C63.3119 12.3532 64.843 11.7024 66.8147 11.7024C67.7807 11.7024 68.7121 11.9164 69.6077 12.343C70.5058 12.7671 71.2655 13.4896 71.8882 14.5107C72.5134 15.5293 72.826 17.0923 72.826 19.1999ZM70.5148 17.3499C70.4225 16.0008 70.0036 15.0283 69.2592 14.4339C68.5135 13.8394 67.6987 13.5422 66.8147 13.5422C65.759 13.5422 64.8891 13.8958 64.2062 14.603C63.522 15.3102 63.1262 16.2263 63.0173 17.3499H70.5148Z",
    fill: "#C1FF72"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M84.6847 12.0039L79.6112 25.4871C79.6035 25.5037 79.5958 25.5332 79.5856 25.5742C79.1038 27.0732 78.5401 28.2916 77.8944 29.2281C77.2487 30.1673 76.3288 30.6375 75.1373 30.6375C74.7376 30.6375 74.2507 30.5529 73.6767 30.3863L73.4512 28.2596C73.8843 28.3928 74.3096 28.4594 74.7273 28.4594C75.5575 28.4594 76.1328 28.2301 76.4543 27.7727C76.7746 27.3141 77.1359 26.4864 77.5357 25.2872L72.498 12.0039H74.9272L78.0481 20.6903C78.2326 21.2233 78.4286 21.91 78.6375 22.7505H78.6887C78.8937 21.7845 79.1602 20.8633 79.4882 19.9882L82.399 12.0039H84.6847Z",
    fill: "#C1FF72"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M18.9116 24.6307H16.3031V15.3395C16.3031 13.7714 16.0213 12.6952 15.4575 12.111C14.8964 11.5242 14.1174 11.2295 13.1206 11.2295C12.3519 11.2295 11.6242 11.4178 10.9375 11.7932C10.2508 12.1699 9.76138 12.699 9.47184 13.3819C9.18485 14.0622 9.04136 15.0257 9.04136 16.2722V24.6307H6.44824V9.3436H8.78V11.5062H8.84149C9.38728 10.6696 10.0612 10.0431 10.8606 9.62546C11.6627 9.20523 12.5941 8.99512 13.6536 8.99512C14.4595 8.99512 15.2551 9.14117 16.0417 9.43072C16.831 9.71771 17.4472 10.1507 17.8918 10.7273C18.3389 11.3051 18.6208 11.9201 18.7374 12.5722C18.8527 13.2256 18.9116 14.1083 18.9116 15.2217V24.6307Z",
    fill: "black"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideHeadLogo);
export default __webpack_public_path__ + "static/media/sideHeadLogo.fd09ce7d4631f0caa2f2ee6e34abdde1.svg";
export { ForwardRef as ReactComponent };